import Modal from 'shared/Modal';
import { FC, useCallback, useState } from 'react';
import { Box, Button, Flex, Text } from 'theme-ui';
import { ACCEPTED_VIDEO_CONTENT } from 'constants/filetypes';
import { TempScenes, TempAudio } from 'types/Scene';
import { useTranslator } from '@picsart/rc/services/localization';

type ChooseFilesForImportModalProps = {
  isOpen: boolean;
  closeHandler: () => void;
  fileNames: { [key: string]: string };
  tempScenes: TempScenes;
  applyHandler: (tempScenes: TempScenes, tempAudio: TempAudio) => void;
  tempAudio: TempAudio;
};

export const ChooseFilesForImportModal: FC<ChooseFilesForImportModalProps> = ({
  closeHandler,
  isOpen,
  fileNames,
  tempScenes,
  applyHandler,
  tempAudio
}) => {
  const [tempFiles, setTempFiles] = useState<{ [key: string]: File }>({});
  const translator = useTranslator();
  const handleInputChange = useCallback(
    fileId => (e: any) => {
      const { files } = e.target;
      if (files && files.length !== 0) {
        setTempFiles(f => ({ ...f, [fileId]: files[0] }));
      }
    },
    []
  );

  const okHandler = useCallback(() => {
    if (!tempFiles || !tempScenes) return;

    const ts = Object.values(tempScenes).reduce((acc, tempScene) => {
      acc[tempScene.id] = {
        ...tempScene,
        file: tempFiles[tempScene.fileId]
      };
      return acc;
    }, {} as TempScenes);

    applyHandler(ts, tempAudio);
    closeHandler();
  }, [tempFiles, tempScenes]);

  return (
    <Modal
      color="transparent"
      opened={isOpen}
      closeHandler={closeHandler}
      title={translator('Choose_video_files_for_importing_to_scenes')}
    >
      <Box sx={{ maxWidth: 600 }}>
        <Flex sx={{ flexDirection: 'column', alignItems: 'center' }}>
          <Box sx={{ maxHeight: 300, overflow: 'scroll' }}>
            {fileNames &&
              Object.entries(fileNames).map(([fileId, fileName], idx) => (
                <Flex key={fileId} sx={{ mt: 4 }}>
                  <Text sx={{ fontSize: 2, mr: 7 }}>
                    {idx + 1}) {fileName}
                  </Text>
                  <input
                    type="file"
                    onChange={handleInputChange(fileId)}
                    name="file"
                    accept={ACCEPTED_VIDEO_CONTENT}
                  />
                </Flex>
              ))}
          </Box>

          <Flex sx={{ alignSelf: 'flex-end' }}>
            <Button
              variant="invertedOutlined"
              onClick={okHandler}
              sx={{ px: 7, py: 4, mt: 6, mr: 3, fontSize: 2 }}
            >
              {translator('Ok')}
            </Button>
            <Button
              variant="primary"
              onClick={closeHandler}
              sx={{
                px: 7,
                py: 4,
                mt: 6,
                borderStyle: 'solid',
                borderWidth: 1,
                borderColor: 'primary',
                fontSize: 2
              }}
            >
              {translator('Cancel')}
            </Button>
          </Flex>
        </Flex>
      </Box>
    </Modal>
  );
};
